module.exports = function (app) {
    app.controller('pages.claims.summary', ["$state", "$scope", "$filter", "services", "invisibleFormService","employerUtility","$window", "$q",'storage',"sessionData",
            function ($state, $scope, $filter, services, invisibleFormService, employerUtility, $window, $q,storage,sessionData) {

                var fetchClaims,
                    dateRangeInit,
                    populateRefineCount,
                    resetRefineCount,
                    sysSrcCodeMap = {
                        medical: 'Medical',
                        dental: 'Dental',
                        vision: 'Vision',
                        ods: 'Drug'
                    };
     
                if ($state && $state.params && $state.params.umi) {
                    //to retain the state params on refresh of the page
                    storage.set('thisUmi', $state.params.umi);                    
                } else if (storage.get("thisUmi")) {
                    $state.params.umi=storage.get("thisUmi")                    
                }

                $scope.$parent.sidebar = {
                    breadCrumb: {
                        primary: {
                            title: "Find Employees",
                            state: "employee.find"
                        },
                        secondary: {
                            title: "Agreement to View Claims",
                            state: "claims({umi:'" + $state.params.umi + "',groupNumber:'"+($state.params.groupNumber ? $state.params.groupNumber : "") +"'})",
                        }, tertiary: {
                            title: "Claims"
                        }
                    }
                };

                $scope.status = {
                    claimSummary: false
                }

                $scope.pagination = {
                    itemsPerPage: '10'
                };
                $scope.pagination.page = 1;
                $scope.refinedClaims=[];

                var agreementId;
                var fetchClaimSummarySupplement;
                fetchClaims = function (dateRange) {
                    var dateRangeObj = JSON.parse(dateRange);
                    $scope.pagination.page = 1;
                    $scope.status.claimSummary = false;
                    fetchClaimSummarySupplement = $q.defer();
                    //Code changes for PM78639
                    services.eprsvc.employeesSummary().fetch($state.params.umi).then(
                        function (response) {
                            agreementId = response.data.payload.agreementNumber;
                            services.rbsmbl.claimSummarySupplement().fetch(agreementId, dateRangeObj.startDate, dateRangeObj.endDate).then(
                                function (response) {
                                    fetchClaimSummarySupplement.resolve(response);
                                },
                                function (error) {
                                    fetchClaimSummarySupplement.reject(error);
                                }
                            );
                            services.eprsvc.claimSummary().fetch(agreementId, $state.params.umi, $state.params.groupNumber, dateRangeObj.startDate, dateRangeObj.endDate).then(
                                function (response) {
                                    $scope.claims = response.data.payload.getClaimAccumActivitySummaryData;
                                    $scope.refine.members = response.data.payload.memberInfos;
                                    resetRefineCount();
                                    populateRefineCount();
                                    $scope.$parent.sidebar.breadCrumb.tertiary.subTitle=" for " + $filter('capitalize')($scope.refine.members[0].firstName) + " " + $filter('capitalize')(($scope.refine.members[0].middleName ? $scope.refine.members[0].middleName : ""))  + " " +  $filter('capitalize')($scope.refine.members[0].lastName);
                                    $scope.status.claimSummary = true;
                                },
                                function (error) {
                                    $scope.status.claimSummary = true;
                                    employerUtility.handleError($scope.claimsFlashes,error);
                                    console.log(error);
                                }
                            );
                        },
                        function (error) {
                        }
                    );



                        
                };

                $scope.getClaimDetails = function (claim) {
                    fetchClaimSummarySupplement.promise.then(
                        function (response) {
                            if (response && response.data && response.data.payload && response.data.payload.claims) {
                                var claimSupplementData = response.data.payload.claims.find(function(i) {
                                    return i.claimNumber == claim.claimNumber;
                                });
                                if (claimSupplementData) {
                                    services.rbsmbl.claimDetailsSupplement().fetch(claim, claimSupplementData, agreementId).then(
                                        function (response) {
                                            if (response && response.data && response.data.payload) {
                                                claim.supplementData = response.data.payload
                                                claim.totalCount = response.data.payload.claimDetail && response.data.payload.claimDetail.length;
                                            }
                                        },
                                        function (error) {
                                            employerUtility.handleError($scope.claimsFlashes,err);
                                            console.error(err);
                                        }
                                    );
                                }
                            }
                        },
                        function (error) {
                        }
                    );
                    // not needed right now
                    // services.eprsvc.claimDetails().fetch(claim, $state.params.umi, agreementId).then(
                    //     function (response) {
                    //         //$scope.claimDetail = response.data.payload.getClaimAccumActivityDetailData;
                    //         claim.totalCount = response.data.payload.totalCount;
                    //     },
                    //     function (err) {
                    //         employerUtility.handleError($scope.claimsFlashes,err);
                    //         console.error(err);
                    //     }
                    // );
                };

                dateRangeInit = function () {
                    var startDate = $state.params.startDate;
                    var endDate = $state.params.endDate;
                    var dateOption;

                    if (!startDate || startDate.length === 0 || !endDate || endDate.length === 0) {
                        startDate = $filter('date')(new Date() - 1 * 365 * 60 * 60 * 24 * 1000, 'yyyyMMdd');
                        endDate = $filter('date')(new Date(), 'yyyyMMdd');
                        dateOption = JSON.stringify({ startDate: startDate, endDate: endDate });
                    } else {
                        dateOption = JSON.stringify({
                            startDate: startDate,
                            endDate: endDate
                        });
                    }

                    var label = $filter('stringToDate')(startDate, 'MM/dd/yyyy') + ' - ' + $filter('stringToDate')(endDate, 'MM/dd/yyyy');


                    var found = false;
                    for (var i = 0; i < $scope.refine.dateRangeOptions.length; i++) {
                        if ($scope.refine.dateRangeOptions[i].value === dateOption) {
                            $scope.refine.dateRange = dateOption;
                            label = dateOption.label;
                            found = true;
                            break;
                        }
                    }
                    if (!found) {
                        $scope.refine.dateRangeOptions.push({ label: label, value: dateOption });
                        $scope.refine.dateRange = dateOption;
                    }

                    fetchClaims($scope.refine.dateRange);
                    $scope.dateRangeText = label;
                };

                populateRefineCount = function () {
                    for (var i = 0; i < $scope.claims.length; i++) {
                        var claim = $scope.claims[i];
                        var item;
                        var j;
                        for ( j = 0; j < $scope.refine.members.length; j++) {
                            item = $scope.refine.members[j];
                            if ((item.firstName.toLowerCase() === claim.mbrFirstNm.toLowerCase()) && (item.lastName.toLowerCase() === claim.mbrLastNm.toLowerCase()) && (item.dateOfBirth.replace(/-/g, "") === claim.mbrBirthDate)) {
                                $scope.refine.members[j].count = $scope.refine.members[j].count + 1;
                                break;
                            }
                        }

                        var check = sysSrcCodeMap[claim.sysSrcCode];
                        for (j = 0; j < $scope.refine.claimTypes.length; j++) {
                            item = $scope.refine.claimTypes[j];
                            if (check === item.label) {
                                $scope.refine.claimTypes[j].count = $scope.refine.claimTypes[j].count + 1;
                                break;
                            }
                        }

                        for (j = 0; j < $scope.refine.claimStatus.length; j++) {
                            item = $scope.refine.claimStatus[j];
                            if (claim.bilgProvClmStaCd === item.code) {
                                $scope.refine.claimStatus[j].count = $scope.refine.claimStatus[j].count + 1;
                                break;
                            }
                        }
                    }
                };

                resetRefineCount = function () {
                    var i = 0;
                    for (i = 0; i < $scope.refine.members.length; i++) {
                        $scope.refine.members[i].count = 0;
                    }
                    for (i = 0; i < $scope.refine.claimTypes.length; i++) {
                        $scope.refine.claimTypes[i].count = 0;
                    }
                    for (i = 0; i < $scope.refine.claimStatus.length; i++) {
                        $scope.refine.claimStatus[i].count = 0;
                    }
                };

                $scope.claimsFilter = function (claim) {
                    var visible = $scope.claimsNameFilter(claim) && $scope.claimsTypeFilter(claim) && $scope.claimsStatusFilter(claim) && $scope.groupFilter(claim);
                    claim.visible = visible;
                    return visible;
                };

                $scope.groupFilter = function(claim){
                    if($state.params.groupNumber && $state.params.groupNumber==claim.clnCnRuleSetClaimsPcsgNo){
                        return true;
                    }else if($state.params.groupNumber){
                        return false;
                    }else{
                        return true;
                    }
                }

                $scope.claimsNameFilter = function (claim) {
                    var checkedCount = 0;
                    for (var i = 0; i < $scope.refine.members.length; i++) {
                        if ($scope.refine.members[i].checked) {
                            checkedCount++;
                        }
                    }
                    if (checkedCount === 0 || checkedCount === $scope.refine.members.length) {
                        // If none are checked, or all are checked, everything should pass the filter
                        return true;
                    }
                    for (var i = 0; i < $scope.refine.members.length; i++) {
                        var item = $scope.refine.members[i];
                        if ((item.firstName.toLowerCase() === claim.mbrFirstNm.toLowerCase()) && (item.lastName.toLowerCase() === claim.mbrLastNm.toLowerCase()) && (item.dateOfBirth.replace(/-/g, "") === claim.mbrBirthDate)) {
                            return Boolean(item.checked);
                        }
                    }
                };

                $scope.claimsTypeFilter = function (claim) {
                    var checkedCount = 0;
                    for (var i = 0; i < $scope.refine.claimTypes.length; i++) {
                        if ($scope.refine.claimTypes[i].checked) {
                            checkedCount++;
                        }
                    }
                    if (checkedCount === 0 || checkedCount === $scope.refine.claimTypes.length) {
                        // If none are checked, or all are checked, everything should pass the filter
                        return true;
                    }

                    var check = sysSrcCodeMap[claim.sysSrcCode];
                    for (var i = 0; i < $scope.refine.claimTypes.length; i++) {
                        var item = $scope.refine.claimTypes[i];
                        if (check === item.label) {
                            return Boolean(item.checked);
                        }
                    }
                };

                $scope.claimsStatusFilter = function (claim) {
                    var checkedCount = 0;
                    for (var i = 0; i < $scope.refine.claimStatus.length; i++) {
                        if ($scope.refine.claimStatus[i].checked) {
                            checkedCount++;
                        }
                    }
                    if (checkedCount === 0 || checkedCount === $scope.refine.claimStatus.length) {
                        // If none are checked, or all are checked, everything should pass the filter
                        return true;
                    }
                    for (var i = 0; i < $scope.refine.claimStatus.length; i++) {
                        var item = $scope.refine.claimStatus[i];
                        if (claim.bilgProvClmStaCd === item.code) {
                            return Boolean(item.checked);
                        }
                    }
                };

                $scope.$watch('refine.dateRange', function (newValue, oldValue) {
                    if (oldValue != newValue) {
                        var i = $scope.refine.dateRangeOptions.length;
                        while (i--) {
                            if ($scope.refine.dateRangeOptions[i].value === newValue) {
                                $scope.dateRangeText = $scope.refine.dateRangeOptions[i].label;
                                if (i < 5) {
                                    $scope.refine.dateRangeOptions.splice(5, 1);
                                }
                            }
                        }
                        services.eprsvc.claimSummary().flushCache();
                        var dateRangeObj = JSON.parse($scope.refine.dateRange);
                        $state.go('claims.summary',{umi:$state.params.umi,startDate:dateRangeObj.startDate,endDate:dateRangeObj.endDate,groupNumber:$state.params.groupNumber});
                    }
                });


                $scope.claimDownloadSummary = function () {
                    var dateRangeObj = JSON.parse($scope.refine.dateRange);
                    var clientNumber="";
                    console.log("for claims summary download",sessionData.clientNumber)
                    if(sessionData && sessionData.basicInfo && sessionData.basicInfo.role && sessionData.basicInfo.role.toLowerCase() == "mcu_admin") {
                        if(sessionData.clientNumber && sessionData.clientNumber !== undefined){
                          //  this.headers['ClientNumber']  = sessionData.clientNumber;
                            clientNumber=sessionData.clientNumber;
                            console.log("for MCU claims summary download",sessionData.clientNumber )
                        }
                    }
                    invisibleFormService.submit(
                        {
                            name: 'GetClaimSummaryXLS',
                            method: 'GET',
                            action: '/eprsvc/x-services/secure/claims/v1/download',
                            target: '_blank',
                            inputs: {
                                startDate :dateRangeObj.startDate,
                                endDate : dateRangeObj.endDate,
                                umi : $state.params.umi,
                                clientNumber:clientNumber,
                                agreementId: agreementId
                            }
                        }
                    );
                };

                $scope.scrollToTop=function(){
                    $window.scrollTo(0, 0);
                }

                $scope.refine.reset=function(){
                    $scope.pagination.page=1;
                };

                dateRangeInit();
            }
        ]
    );
};
